import { LogOut, ShieldAlert } from "lucide-react";
import { ApogeuLogo } from "../components/ApogeuLogo";
import { Button } from "../components/Button";
import { MessageBanner } from "../components/MessageBanner";

interface AccessDeniedScreenProps {
  readonly email: string | null;
  readonly onLogout: () => void;
  readonly error?: string | null;
}

export function AccessDeniedScreen({ email, onLogout, error }: AccessDeniedScreenProps) {
  return (
    <div className="auth-screen auth-screen--dark">
      <div className="brand-tile brand-tile--large">
        <ApogeuLogo width={54} />
      </div>
      <div className="auth-screen__content auth-screen__content--center">
        <ShieldAlert size={30} color="#A6D608" aria-hidden="true" />
        <h1 className="auth-screen__title">Acesso não liberado</h1>
        <p className="auth-screen__subtitle">
          O Apogeu App é exclusivo para alunos e professores dos CTs. Se você faz parte da gestão,
          use o Apogeu OS.
        </p>
        {email && <span className="auth-screen__email">{email}</span>}
        {error && <MessageBanner>{error}</MessageBanner>}
        <Button variant="primary" fullWidth onClick={onLogout}>
          <LogOut size={17} aria-hidden="true" />
          Entrar com outra conta
        </Button>
      </div>
      <div className="auth-screen__footer">
        <span>Apogeu App · alunos e professores</span>
      </div>
    </div>
  );
}
